import { CircularProgress } from "@chakra-ui/react";
import "./Loading.css";
/**
 * Function component for displaying a loading indicator.
 *
 * @return {JSX.Element} The loading indicator UI.
 */
function Loading() {
  return (
    <main className="loading_main">
      <CircularProgress
        isIndeterminate
        color="#007749"
        trackColor="transparent"
        size={"105px"}
      />
    </main>
  );
}

export default Loading;
